import React from 'react';
import { Link } from 'react-router-dom';
import './SupportPages.css';

const Support: React.FC = () => {
  return (
    <div className="support-page">
      <div className="container">
        <div className="support-header">
          <h1 className="section-title">고객지원</h1>
          <p className="section-subtitle">
            EasyAutoCall 이용에 필요한 모든 도움을 드립니다
          </p>
        </div>

        <div className="support-grid">
          <Link to="/faq" className="support-card">
            <div className="support-card-icon">❓</div>
            <h3>자주 묻는 질문</h3>
            <p>자주 묻는 질문과 답변을 확인하세요</p>
            <span className="support-card-link">바로가기 →</span>
          </Link>

          <Link to="/contact" className="support-card">
            <div className="support-card-icon">💬</div>
            <h3>문의하기</h3>
            <p>1:1 문의를 남겨주시면 빠르게 답변드립니다</p>
            <span className="support-card-link">바로가기 →</span>
          </Link>

          <a href="tel:02-6052-1192" className="support-card">
            <div className="support-card-icon">📞</div>
            <h3>전화 문의</h3>
            <p>02-6052-1192 (평일 09:00-18:00)</p>
            <span className="support-card-link">전화걸기 →</span>
          </a>

          <a href="mailto:support@seoul-soft.com" className="support-card">
            <div className="support-card-icon">📧</div>
            <h3>이메일 문의</h3>
            <p>support@seoul-soft.com</p>
            <span className="support-card-link">메일보내기 →</span>
          </a>
        </div>

        <div className="support-guides">
          <h2 className="guides-title">서비스 가이드</h2>
          <div className="guides-grid">
            <div className="guide-item">
              <h4>시작하기</h4>
              <ul>
                <li><a href="#signup">회원가입 방법</a></li>
                <li><a href="#credit">크레딧 충전하기</a></li>
                <li><a href="#first-call">첫 발신하기</a></li>
              </ul>
            </div>

            <div className="guide-item">
              <h4>TTS 전화</h4>
              <ul>
                <li><a href="#single">단건 발신</a></li>
                <li><a href="#bulk">대량 발신 (엑셀)</a></li>
                <li><a href="#schedule">예약 발신</a></li>
              </ul>
            </div>

            <div className="guide-item">
              <h4>TTS 설문조사</h4>
              <ul>
                <li><a href="#survey-create">설문 만들기</a></li>
                <li><a href="#survey-send">설문 발송하기</a></li>
                <li><a href="#survey-result">결과 확인하기</a></li>
              </ul>
            </div>

            <div className="guide-item">
              <h4>통계 및 리포트</h4>
              <ul>
                <li><a href="#dashboard">대시보드 활용</a></li>
                <li><a href="#history">발신 이력 조회</a></li>
                <li><a href="#export">데이터 내보내기</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="support-tips">
          <h2 className="tips-title">💡 유용한 팁</h2>
          <div className="tips-list">
            <div className="tip-item">
              <h4>크레딧을 효율적으로 사용하는 방법</h4>
              <p>대량 발신 시 엑셀 파일의 전화번호 형식을 미리 확인하고, 중복 번호를 제거하면 불필요한 크레딧 소진을 방지할 수 있습니다.</p>
            </div>
            <div className="tip-item">
              <h4>발신 성공률을 높이는 방법</h4>
              <p>오전 10시~11시, 오후 2시~4시에 발신하면 응답률이 높습니다. 휴일이나 심야 시간대는 피하는 것이 좋습니다.</p>
            </div>
            <div className="tip-item">
              <h4>메시지 작성 팁</h4>
              <p>짧고 명확한 메시지가 효과적입니다. 30초 이내로 핵심 내용을 전달하고, 중요한 정보는 처음에 배치하세요.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
